import React, { useState, Fragment, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from '@progress/kendo-react-inputs'
import { Label } from '@progress/kendo-react-labels'
import './signatory-list.css'
import { GridSelectionHLPure, CheckBoxHLPure, SearchBarHLPure, DialogFormHLPure, ButtonHLPure, ButtonAddHLPure, InputHLPure, DialogDescriptionHLPure, PhoneInputHLPure, TooltipHLPure } from '../../pures'
import DropdownPure from '../dropDownHL/dropDownHL.pure'
import { Grid } from '@material-ui/core'
const TooltipContentTemplate = (props) => {
  return (
    <a>
      <p>{props.content}</p>
    </a>
  )
}

function DialogSignerContainer(props) {
  const { t, i18n } = useTranslation()
  const searchTimeoutRef = useRef(null)
  const [isLoadig, setIsLoadig] = useState(false)
  const [showDialogNewCollaborator, setShowDialogNewCollaborator] = useState(false)
  const [usersGridSelected, setUsersGridSelected] = useState([])
  const [usersGridNotSelected, setUsersGridNotSelected] = useState([])
  const [dataUsers, setDataUsers] = useState(
    props.buttonType === 2 || props.buttonType === 4
      ? props.collaboratorListAllow
      : props.inviteListAllow
  )
  // Derive filtered lists from state instead of keeping a separate copy
  const [userFilter, setUsersGridFilter] = useState('')
  const [dataFilterGrid, setDataGridFilterGrid] = useState(
    props.buttonType === 4 ? props.validators : props.signers
  )
  const [titleHeader, setTitleHeader] = useState(t('dialogSignerList2.addSigner'))
  const [showDescription, setShowDescription] = useState(false)
  const [btnAdd, setBtnAdd] = useState(t('signatureRequestView2.add.invited'))
  const [searchBtn, setSearchBtn] = useState(t('signatureRequestView2.search.invited'))
  const [description, setDescription] = useState('')
  const [dialogAddDescriptionActive, setDialogAddDescriptionActive] = useState(false)
  const [dialogAddDescription, setDialogAddDescription] = useState('')
  const [titleNewSigner, setTitleNewSigner] = useState(t('signatureRequestView2.new.colab'))
  const [firstInvites, setFirstInvites] = useState(
    (props.buttonType === 2 || props.buttonType === 4)
      ? []
      : props.inviteListAllow
  )

  const systemLanguage = (i18n?.language || 'es').toLowerCase().startsWith('es') ? 'es' : 'en'
  const defaultLanguageId = systemLanguage === 'es' ? 1 : 2
  const [preferredLanguage, setPreferredLanguage] = useState(defaultLanguageId)
  const [signWithoutPassword, setSignWithoutPassword] = useState(false)
  const [cellPhoneNumber, setCellPhoneNumber] = useState('')

  const [emptyFieldErrors, setEmptyFieldErrors] = useState({
    email: false,
    firstName: false,
    firstLastName: false,
    cellPhone: false,
  })

  const languageOptions = systemLanguage === 'es'
    ? [
      { name: 'Español', value: 1 },
      { name: 'Inglés', value: 2 }
    ]
    : [
      { name: 'English', value: 2 },
      { name: 'Spanish', value: 1 }
    ]

  const containerGroupButtonsStyles = {
    display: 'inline-flex',
    justifyContent: 'right',
    alignItems: 'center',
    marginTop: '30px',
  }

  const styleGrid = {
    fontFamily: 'Quicksand, sans-serif',
    maxHeight: 'calc(50px * 5.5)',
    overflowY: 'auto',
    overflowX: 'hidden',
    overscrollBehavior: 'contain',
    borderRight: '1px solid rgb(200, 200, 200) !important',
    maxHeight: '281px'
  }

  const filterChangeUsers = (e) => {
    setUsersGridFilter(e.target.value)
  }

  const onChangeCheckBox = (event, dataItem) => {
    //Array users
    const updatedData = dataUsers.map((item) => {
      if (item.id === dataItem.id) {
        return { ...item, isAssigned: event.target.checked }
      }
      return item
    })
    setDataUsers(updatedData)

    //Array users not selected
    let filteredDataNotSelected = updatedData.filter(item => item.isAssigned === false)
    setUsersGridNotSelected(filteredDataNotSelected)
    //Array selected users
    let selectedDataItems = updatedData.filter(item => item.isAssigned)
    setUsersGridSelected(selectedDataItems)
  }

  useEffect(() => {
    if (usersGridSelected.length > 0 || usersGridNotSelected.length > 0) {
      props.saveArraSelectedList(usersGridSelected, usersGridNotSelected)
    }
  }, [usersGridSelected, usersGridNotSelected])

  // Clear any pending search timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current)
    }
  }, [])

  useEffect(() => {
    if (props.buttonType === 2 || props.buttonType === 4) {
      setDataUsers(props.collaboratorListAllow || [])
      setFirstInvites([])
    } else {
      setDataUsers(props.inviteListAllow || [])
      setFirstInvites(props.inviteListAllow || [])
    }
  }, [props.buttonType])

  useEffect(() => {
    setDataGridFilterGrid(props.buttonType === 4 ? props.validators : props.signers)
  }, [props.buttonType, props.validators, props.signers])


  // Base list excludes users already added to the grid (by email)
  const baseList = React.useMemo(() => {
    if (!Array.isArray(dataUsers)) return []
    if (!Array.isArray(dataFilterGrid) || dataFilterGrid.length === 0) return dataUsers
    const emailsInGrid = new Set(dataFilterGrid.map(i => i.email))
    return dataUsers.filter(u => !emailsInGrid.has(u.email))
  }, [dataUsers, dataFilterGrid])

  useEffect(() => {
    let title = ''
    let showDescription = false
    let btnAdd = t('signatureRequestView2.add.invited')
    let btnSearch = t('signatureRequestView2.search.invited')
    let description = t('dialogSignerList2.invitationmessage')
    let titleNewSigner = t('signatureRequestView2.new.colab')
    let dialogDescription = ''
    let dialogDescriptionActive = false

    switch (props.buttonType) {
      case 0:
        title = t('dialogSignerList2.addSigner')
        showDescription = true
        description = t('dialogSignerList2.invitationmessage')
        titleNewSigner = t('signatureRequestView2.new.invited')
        break
      case 2:
        title = t('dialogSignerList2.addCollaborator')
        btnAdd = t('signatureRequestView2.add.colab')
        btnSearch = t('signatureRequestView2.search.colab')
        titleNewSigner = t('signatureRequestView2.new.colab')
        break
      case 4:
        title = t('dialogSignerList2.addValidator')
        btnAdd = t('signatureRequestView2.add.colab')
        btnSearch = t('signatureRequestView2.search.colab')
        titleNewSigner = t('signatureRequestView2.new.colab')
        break
      case 5:
        title = t('signatureRequestView2.add.signers.no.password')
        btnAdd = t('signatureRequestView2.add.signer.no.password')
        showDescription = true
        btnSearch = t('Buscar firmante')
        description = t('signatureRequestView2.description.signer.no.password')
        titleNewSigner = t('signatureRequestView2.title.new.signer.no.password')
        dialogDescription = t('signatureRequestView2.title.invited_signer.no_description')
        dialogDescriptionActive = true
        break
      default:
        title = t('dialogSignerList2.addSigner')
        showDescription = true
        btnAdd = t('signatureRequestView2.add.invited')
        btnSearch = t('signatureRequestView2.search.invited')
        description = t('dialogSignerList2.invitationmessage')
        titleNewSigner = t('signatureRequestView2.new.colab')
        break
    }

    setTitleHeader(title)
    setShowDescription(showDescription)
    setBtnAdd(btnAdd)
    setSearchBtn(btnSearch)
    setDescription(description)
    setTitleNewSigner(titleNewSigner)
    setDialogAddDescription(dialogDescription)
    setDialogAddDescriptionActive(dialogDescriptionActive)
  }, [props.buttonType, t])

  const filteredData = React.useMemo(() => {
    if (!userFilter) return baseList
    const term = userFilter.toLowerCase()
    return baseList.filter(item => ((item.name || '').toLowerCase().includes(term) || (item.email || '').toLowerCase().includes(term)))
  }, [baseList, userFilter])

  const onClickNewCollaborator = () => {
    setShowDialogNewCollaborator(true)
    // Resetear errores al abrir el formulario
    setEmptyFieldErrors({
      email: false,
      firstName: false,
      firstLastName: false,
      cellPhone: false,
    })
  }

  const handleCancelDialog = () => {
    // Limpiar errores al cancelar
    setEmptyFieldErrors({
      email: false,
      firstName: false,
      firstLastName: false,
      cellPhone: false,
    })
    props.cancel()
  }

  const handleSaveWithValidation = () => {
    // Resetear errores previos
    setEmptyFieldErrors({
      email: false,
      firstName: false,
      firstLastName: false,
      cellPhone: false,
    })

    const errors = {
      email: false,
      firstName: false,
      firstLastName: false,
      cellPhone: false,
    }

    // Validar campos requeridos según el tipo de formulario
    if (props.buttonType === 5) {
      // Formulario de invitado sin contraseña
      if (!props.signerInEdit.email || props.signerInEdit.email.trim() === '') {
        errors.email = true
      }
      if (!props.signerInEdit.nameSigner || props.signerInEdit.nameSigner.trim() === '') {
        errors.firstName = true
      }
      if (!props.signerInEdit.firstLastNameSigner || props.signerInEdit.firstLastNameSigner.trim() === '') {
        errors.firstLastName = true
      }
      if (!props.signerInEdit.phoneNumber || props.signerInEdit.phoneNumber.trim() === '') {
        errors.cellPhone = true
      }
    } else {
      // Formulario de colaborador/invitado estándar
      if (!props.signerInEdit.email || props.signerInEdit.email.trim() === '') {
        errors.email = true
      }
      if (!props.signerInEdit.firstName || props.signerInEdit.firstName.trim() === '') {
        errors.firstName = true
      }
      if (!props.signerInEdit.firstLastName || props.signerInEdit.firstLastName.trim() === '') {
        errors.firstLastName = true
      }
      // Para invitados (buttonType === 0) con checkbox marcado, validar teléfono
      if (props.buttonType === 0 && signWithoutPassword) {
        if (!cellPhoneNumber || cellPhoneNumber.trim() === '') {
          errors.cellPhone = true
        }
      }
    }

    // Si hay errores, mostrarlos y no continuar
    if (errors.email || errors.firstName || errors.firstLastName || errors.cellPhone) {
      setEmptyFieldErrors(errors)
      return
    }

    // Agregar languageId, isSignerNoPassword y cellPhone al signerInEdit antes de guardar
    const updatedSignerInEdit = {
      ...props.signerInEdit,
      languageId: preferredLanguage,
      isSignerNoPassword: signWithoutPassword,
      cellPhone: signWithoutPassword && props.buttonType === 0 ? cellPhoneNumber : undefined
    }

    // Actualizar el signerInEdit en el componente padre con los nuevos valores
    if (props.onDialogInputChange) {
      props.onDialogInputChange({
        target: {
          name: 'languageId',
          value: preferredLanguage
        }
      })
      props.onDialogInputChange({
        target: {
          name: 'isSignerNoPassword',
          value: signWithoutPassword
        }
      })
      if (signWithoutPassword && props.buttonType === 0) {
        props.onDialogInputChange({
          target: {
            name: 'cellPhone',
            value: cellPhoneNumber
          }
        })
      }
    }

    // Si no hay errores, llamar a la función handleSubmit original
    props.handleSubmit()
  }

  const handleEmailChange = (event) => {
    // Limpiar error de email al escribir
    if (emptyFieldErrors.email) {
      setEmptyFieldErrors(prev => ({ ...prev, email: false }))
    }
    props.changeSignerEmailInEdit(event)
  }

  const handleInputChange = (event) => {
    // Limpiar error del campo correspondiente al escribir
    const fieldName = event.target.name
    if (fieldName === 'firstName' || fieldName === 'nameSigner') {
      if (emptyFieldErrors.firstName) {
        setEmptyFieldErrors(prev => ({ ...prev, firstName: false }))
      }
    } else if (fieldName === 'firstLastName' || fieldName === 'firstLastNameSigner') {
      if (emptyFieldErrors.firstLastName) {
        setEmptyFieldErrors(prev => ({ ...prev, firstLastName: false }))
      }
    } else if (fieldName === 'cellPhone' || fieldName === 'cellPhoneSigner') {
      if (emptyFieldErrors.cellPhone) {
        setEmptyFieldErrors(prev => ({ ...prev, cellPhone: false }))
      }
    }
    props.onDialogInputChange(event)
  }

  const handlePhoneNumberChange = (phoneNumber) => {
    // Limpiar error de teléfono al escribir
    if (emptyFieldErrors.cellPhone) {
      setEmptyFieldErrors(prev => ({ ...prev, cellPhone: false }))
    }
    setCellPhoneNumber(phoneNumber)
    if (props.onChangePhoneNumber) {
      props.onChangePhoneNumber(phoneNumber)
    }
  }

  const handleSignWithoutPasswordChange = (event) => {
    const checked = event.target.checked
    setSignWithoutPassword(checked)
    // Limpiar error de teléfono al desmarcar
    if (!checked && emptyFieldErrors.cellPhone) {
      setEmptyFieldErrors(prev => ({ ...prev, cellPhone: false }))
    }
  }

  const headerColumnOne = (props) => {
    let styleHeader = {
      color: '#123513',
      fontSize: '14px',
      fontWeight: 600,
      display: 'flex',
      justifyContent: 'start',
      fontFamily: 'Quicksand',
      paddingLeft: '20px',
    }
    return <span style={styleHeader}>{props.title}</span>
  }

  const cellColumnOne = (props) => {
    return (
      <td className='dialogSigner-cell-one'>
        <div className='dialogSigner-cell-one-div'>
          <CheckBoxHLPure
            valueCheckBox={props.dataItem}
            checkedState={props.dataItem.isAssigned}
            onChangeHandler={(event) => onChangeCheckBox(event, props.dataItem)}
          />
          <div className='text-double'>
            <span className='dialogSigner-containerLabel'>
              {props.dataItem.name}
            </span>
            <span className='dialogSigner-subtitle-containerLabel'>
              {props.dataItem.email}
            </span>
          </div>
        </div>
      </td>
    )
  }

  const searchByEmail = async (e) => {
    const value = e.target.value
    // Always update local filter
    setUsersGridFilter(value)

    // Cancel any pending debounced search
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current)

    // When cleared, restore initial invites
    if (!value) {
      // Restore original snapshot (state before first search)
      setDataUsers(dataUsers.map(i => ({ ...i })))
      return
    }

    // Debounce remote search for 2 seconds when length >= 4
    if (value.length >= 4) {
      searchTimeoutRef.current = setTimeout(async () => {
        const searchType = (props.buttonType === 5) ? 3 : 2
        try {
          const invitesCollabs = await props.getCollabsOrInvites(searchType, null, null, value)
          const results = (invitesCollabs && invitesCollabs.invites) ? invitesCollabs.invites : []
          setDataUsers(prev => {
            const map = new Map()
              ;[...prev, ...results].forEach(u => {
                if (u && u.email) map.set(u.email, u)
              })
            return Array.from(map.values())
          })
        } catch (_) { /* ignore errors */ }
      }, 800)
    }
  }

  const onKeyPress = async (e) => {
    if (e.key !== 'Enter') return
    if (!userFilter || props.buttonType === 2 || props.buttonType === 4 || userFilter.length < 4) return
    e.preventDefault()
    // Cancel any pending debounced call and fetch immediately
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current)
    const searchType = (props.buttonType === 5) ? 3 : 2
    try {
      const invitesCollabs = await props.getCollabsOrInvites(searchType, null, null, userFilter)
      const results = (invitesCollabs && invitesCollabs.invites) ? invitesCollabs.invites : []
      setDataUsers(prev => {
        const map = new Map()
          ;[...prev, ...results].forEach(u => {
            if (u && u.email) map.set(u.email, u)
          })
        return Array.from(map.values())
      })
    } catch (_) { /* ignore errors */ }
  }

  return (
    <div
      style={
        props.showErrorDomain === true || props.showErrorDomainInvited === true
          ? { display: 'none' }
          : null
      }
    >
      <Fragment>
        {!showDialogNewCollaborator ?
          <DialogFormHLPure
            className='custom-title invitation-modal'
            titleDialog={titleHeader}
            descriptionActive={showDescription}
            descriptionDialog={description}
            textBtnCancel={t('button.cancel')}
            cancel={handleCancelDialog}
            saveBtn={t('button.accept')}
            handleSubmit={props.handleSubmitList}

          >
            <div className='dialog-invitation-form'>
              <div className='dialogSigner-formButtons'>
                <ButtonAddHLPure
                  nameBtn={btnAdd}
                  onClickBtn={onClickNewCollaborator}
                  iconAdd={true}
                />
                <SearchBarHLPure
                  placeholder={searchBtn}
                  onSearchChange={(props.buttonType === 2 || props.buttonType === 4) ? (e) => filterChangeUsers(e) : (e) => searchByEmail(e)}
                  searchValue={userFilter}
                  tooltip={!(props.buttonType === 2 || props.buttonType === 4)}
                  positionTooltip={'right'}
                  titleTooltip={t('dialogSignerList2.tooltip.title')}
                  descriptionTooltip={t('dialogSignerList2.tooltip.description')}
                  informationIcon={!(props.buttonType === 2 || props.buttonType === 4)}
                  onKeyPress={(e) => onKeyPress(e)}
                />
              </div>
              <div className='dialog-invitation-grid'>
                <GridSelectionHLPure
                  skip={0}
                  take={6}
                  dataGrid={filteredData}
                  filter={true}
                  onFilterChange={filterChangeUsers}
                  styleGrid={styleGrid}
                  cellColumnOne={cellColumnOne}
                  headerColumnOne={headerColumnOne}
                  widthColumnOne={100}
                  pageable={false}
                  isCheckedColOne={''}
                  styleGeneral
                  styleGeneralClass='dialog-signer-gridSelectionGLPure'
                />
              </div>
            </div>
          </DialogFormHLPure>
          : (
            <DialogFormHLPure
              descriptionActive={dialogAddDescriptionActive}
              descriptionDialog={dialogAddDescription}
              titleDialog={titleNewSigner}
              cancel={props.cancel}
              showChildrenBottom
              childrenBottom={<>
                <Grid className='dialogFormHLPure-buttons'>
                  <ButtonHLPure
                    nameBtn={t('button.return')}
                    onClickBtn={handleCancelDialog}
                  />
                  <ButtonHLPure
                    primary={true}
                    nameBtn={t('button.save')}
                    onClickBtn={handleSaveWithValidation}
                  />
                </Grid>
              </>
              }
            >
              {props.buttonType !== 5 &&

                <div className='dialog-invitation-form'>
                  <div style={{ marginBottom: '14px', lineHeight: '1' }}>
                    <InputHLPure
                      typeInput='email'
                      labelInput={t('dialogSignerList2.email') + ' *'}
                      inputTypeBox={false}
                      valueInput={props.signerInEdit.email || ''}
                      handleChangeInput={(event) => handleEmailChange(event)}
                      inputActive
                    />

                    {emptyFieldErrors.email && (
                      <span className='hint-message-error'>
                        {t('dialogSignerList2.requiredField')}
                      </span>
                    )}
                    {!emptyFieldErrors.email && props.errorCurrentEmail === true && (
                      <span className='hint-message-error'>
                        {t('dialogSignerList2.errorEmailNotvalid')}
                      </span>
                    )}
                    {!emptyFieldErrors.email && props.errorCurrentEmailRegister === true &&
                      props.errorCurrentEmail === false && (
                        <span className='hint-message-error'>
                          {t('dialogSignerList2.errorEmailAlreadyRegister')}
                        </span>
                      )}
                  </div>
                  <div style={{ marginBottom: '14px', lineHeight: '1' }}>
                    <Label className='dialog-signers-labels'>
                      {t('dialogSignerList2.name')} *
                    </Label>
                    <div>
                      <Input
                        className='input-add-colaborator'
                        type='name'
                        name='firstName'
                        disabled={isLoadig}
                        minLength={2}
                        value={props.signerInEdit.firstName || ''}
                        onChange={(event) => handleInputChange(event)}
                        validator={props.validator.nameValidator}
                        component={props.validateInput}
                      />
                    </div>
                    {emptyFieldErrors.firstName && (
                      <span className='hint-message-error'>
                        {t('dialogSignerList2.requiredField')}
                      </span>
                    )}
                    {!emptyFieldErrors.firstName && props.errorCurrentName && (
                      <span className='hint-message-error'>
                        {t('dialogSignerList2.errorFirstNamesNotvalid')}
                      </span>
                    )}
                  </div>
                  <div style={{ marginBottom: '14px', lineHeight: '1' }}>
                    <Label className='dialog-signers-labels'>
                      {t('dialogSignerList2.firstLastName')} *
                    </Label>
                    <Input
                      className='input-add-colaborator'
                      type='name'
                      name='firstLastName'
                      minLength={2}
                      disabled={isLoadig}
                      value={props.signerInEdit.firstLastName || ''}
                      onChange={(event) => handleInputChange(event)}
                      validator={props.validator.nameValidator}
                      component={props.validateInput}
                    />

                    {emptyFieldErrors.firstLastName && (
                      <span className='hint-message-error'>
                        {t('dialogSignerList2.requiredField')}
                      </span>
                    )}
                    {!emptyFieldErrors.firstLastName && props.errorCurrentFirstLastName && (
                      <span className='hint-message-error'>
                        {t('dialogSignerList2.errorFirstLastNameNotvalid')}
                      </span>
                    )}
                  </div>
                  <div style={{ marginBottom: '14px', lineHeight: '1' }}>
                    <Label className='dialog-signers-labels'>
                      {t('dialogSignerList2.secondLastName')}
                    </Label>
                    <Input
                      className='input-add-colaborator'
                      type='name'
                      name='secondLastName'
                      minLength={2}
                      disabled={isLoadig}
                      value={props.signerInEdit.secondLastName || ''}
                      onChange={(event) => props.onDialogInputChange(event)}
                      validator={props.validator.nameValidator}
                      component={props.validateInput}
                    />

                    {props.errorCurrentSecondLastName && (
                      <span className='hint-message-error'>
                        {t('dialogSignerList2.errorSecondLastNameNotvalid')}
                      </span>
                    )}
                  </div>
                  <div style={{ marginBottom: '14px', lineHeight: '1' }}>
                    <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                      <CheckBoxHLPure
                        labelCheckBox={t('dialogSignerList2.signWithoutPassword')}
                        checkedState={signWithoutPassword}
                        onChangeHandler={handleSignWithoutPasswordChange}
                      />
                      <TooltipHLPure
                        positionTooltip={'top'}
                        titleTooltip={t('dialogSignerList2.tooltip.title.signWithoutPassword')}
                        descriptionTooltip={
                          props.buttonType === 0
                            ? t('dialogSignerList2.tooltip.description.signWithoutPassword.invited')
                            : t('dialogSignerList2.tooltip.description.signWithoutPassword.collaborator')
                        }
                        informationIcon
                      />
                    </div>
                    {props.buttonType === 0 && signWithoutPassword && (
                      <div style={{ marginTop: '14px' }}>
                        <Label className='dialog-signers-labels'>
                          {t('dialogSignerList2.cellPhone')} *
                        </Label>
                        <PhoneInputHLPure
                          placeholder={t('profileAdministrationPrincipalView.phone.placeholder')}
                          value={cellPhoneNumber}
                          onCellphoneChange={handlePhoneNumberChange}
                          defaultCountry={'MX'}
                          international={true}
                          limitMaxLength
                          countryCallingCodeEditable={false}
                        />
                        {emptyFieldErrors.cellPhone && (
                          <span className='hint-message-error'>
                            {t('dialogSignerList2.requiredField')}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                  <div style={{ marginBottom: '14px', lineHeight: '1' }}>
                    <div style={{ display: 'flex', gap: '5px', marginBottom: '15px', alignItems: 'center' }}>
                      <Label className='dialog-signers-labels'>
                        {t('dialogSignerList2.preferredLanguage')}
                      </Label>
                      <TooltipHLPure
                        positionTooltip={'top'}
                        titleTooltip={t('dialogSignerList2.tooltip.title.language')}
                        descriptionTooltip={t('dialogSignerList2.tooltip.description.language')}
                        informationIcon
                      />
                    </div>
                    <DropdownPure
                      optionsDropDown={languageOptions}
                      optionsValue={preferredLanguage}
                      valueItem='value'
                      nameOption='name'
                      onDropDownChange={(e) => setPreferredLanguage(e.target.value)}
                    />
                  </div>
                </div>
              }
            </DialogFormHLPure>
          )}
      </Fragment>
    </div>
  )
}

export { DialogSignerContainer as default }
